import React from "react";
import "./NotFound.scss";

function NotFound({
  title = "404 - Page Not Found",
  message = "The page you are looking for does not exist.",
}) {
  return (
    <div className="not-found">
      <h1>{title}</h1>
      <p>{message}</p>
    </div>
  );
}

export default NotFound;
